import React from 'react';
import materialBanner from '../../assets/Material.png';
import './Hero.scss';

const Hero = () => (
  <section className="hero" id="hero">
    <div className="hero-media">
      <img
        src={materialBanner}
        alt="Aavjo Industries aerial lifts and material handling equipment manufacturer in Ahmedabad"
        className="hero-bg-img"
      />
      <div className="hero-overlay" />
    </div>

    <div className="hero-actions-wrap">
      <a href="/#materialHandling" className="btn-hero-primary">
        Explore Products ↓
      </a>
      <a href="/#contact" className="btn-hero-outline">
        Request a Demo
      </a>
    </div>
  </section>
);

export default Hero;
